import { graphql } from "../gql";
import { useQuery } from "urql";
const getIntegrationsQuery = graphql(`
  query GetIntegrations {
    getIntegrations {
      integrations {
        id
        customerId
        integrationType
        integrationSource
        displayName
        createdAt
        updatedAt
      }
    }
  }
`);
export const useGetIntegrationsQuery = () => useQuery({ query: getIntegrationsQuery });
export { getIntegrationsQuery };
